export enum ActionType{
    updateIsUserLoggedIn,
    registerToSocketsIO
}